import { MessageCircle } from "lucide-react";

const WA_NUMBER = "919428609248";
const WA_MSG = "greetings oits i would like to have a custom made tour";

export default function WhatsAppButton() {
  const href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MSG)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with OITS on WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl hover:scale-105 hover:shadow-2xl transition-transform duration-200"
    >
      <MessageCircle className="h-6 w-6" fill="currentColor" />
      <span className="sr-only">WhatsApp</span>
    </a>
  );
}
